/**
 * Header scroll behavior - hides header on scroll down, shows on scroll up
 * Also handles anchor navigation to keep header visible
 */
(function () {
  const SCROLL_THRESHOLD = 10;
  const HIDE_SCROLL_POSITION = 300;
  const NAVIGATION_TIMEOUT = 3000;
  const MANUAL_SCROLL_TIMEOUT = 150;

  // Class name constants
  const TRANSPARENT_CLASSES = ['bg-transparent', 'border-transparent', 'backdrop-blur-none', 'dark:bg-transparent'];
  const VISIBLE_CLASSES = ['bg-gray-100/60', 'backdrop-blur-md', 'border-neutral-200', 'dark:bg-neutral-900/80', 'dark:border-neutral-800'];

  // State variables
  let lastScroll = 0;
  let ticking = false;
  let navigationClicked = false;
  let scrollTimeout = null;

  // DOM elements
  const header = document.getElementById('main-header');
  const headerBg = document.getElementById('header-bg');

  // Early return if elements don't exist
  if (!header || !headerBg) {
    console.warn('Header elements not found');
    return;
  }

  /**
   * Updates header visibility and background based on scroll position
   */
  function updateHeader() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    // Add background and border when scrolled past threshold or navigation clicked
    if (currentScroll > SCROLL_THRESHOLD || navigationClicked) {
      headerBg.classList.remove(...TRANSPARENT_CLASSES);
      headerBg.classList.add(...VISIBLE_CLASSES);
    } else {
      headerBg.classList.add(...TRANSPARENT_CLASSES);
      headerBg.classList.remove(...VISIBLE_CLASSES);
    }

    // If navigation was clicked, keep header visible
    if (navigationClicked) {
      header.style.transform = 'translateY(0)';
      lastScroll = currentScroll <= 0 ? 0 : currentScroll;
      ticking = false;
      return;
    }

    // Hide on scroll down, show on scroll up
    if (currentScroll > lastScroll && currentScroll > HIDE_SCROLL_POSITION) {
      // Scrolling down
      header.style.transform = 'translateY(-100%)';
    } else {
      // Scrolling up
      header.style.transform = 'translateY(0)';
    }

    lastScroll = currentScroll <= 0 ? 0 : currentScroll;
    ticking = false;
  }

  /**
   * Handles scroll events with requestAnimationFrame for performance
   */
  function onScroll() {
    // If user manually scrolls after navigation, reset the flag
    if (navigationClicked && scrollTimeout) {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        navigationClicked = false;
      }, MANUAL_SCROLL_TIMEOUT);
    }

    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }

  /**
   * Handles anchor navigation clicks to keep header visible
   */
  function onAnchorClick() {
    navigationClicked = true;
    header.style.transform = 'translateY(0)';

    // Immediately add background when navigation is clicked
    headerBg.classList.remove(...TRANSPARENT_CLASSES);
    headerBg.classList.add(...VISIBLE_CLASSES);

    // Reset the flag after scroll completes
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }
    scrollTimeout = setTimeout(() => {
      navigationClicked = false;
    }, NAVIGATION_TIMEOUT);
  }

  /**
   * Handles mobile navigation clicks - closes dialog then navigates to anchor
   */
  function handleMobileNavClick(e) {
    e.preventDefault();

    const dialog = document.getElementById('mobile-menu');

    const href = e.currentTarget.getAttribute('href');
    const anchor = href.substring(1); // Remove leading '/'

    if (dialog) {
      dialog.close();
    }

    // Navigate to anchor after brief delay to ensure dialog closes
    setTimeout(() => {
      window.location.hash = anchor;
      onAnchorClick(); // Maintain header visibility behavior
    }, 50);
  }

  // Add click listeners to all anchor links (wait for DOM to be ready)
  document.addEventListener('DOMContentLoaded', function () {
    const anchorLinks = document.querySelectorAll('a[href^="/#"]');
    anchorLinks.forEach(link => {
      link.addEventListener('click', onAnchorClick);
    });

    // Add special handling for mobile navigation links
    const mobileNavLinks = document.querySelectorAll('a[href^="/#"][command="close"]');
    mobileNavLinks.forEach(link => {
      link.addEventListener('click', handleMobileNavClick);
    });
  });

  // Add scroll listener with passive flag for better performance
  window.addEventListener('scroll', onScroll, { passive: true });
})();
